(function() {
  'use strict';

  function BulkActionsController(
      $log,
      $rootScope,
      $translate,
      ApiIDList,
      AsyncTasksSearch,
      CeleryTasks,
      Profile,
      List,
      Utils,
      BULK_ACTIONS_STATES) {
    var ctrl = this;

    Utils.setPageTitle($translate.instant('Bulk actions'));

    ctrl.$onInit = function() {
      ctrl.options = {
        trackBy: '_id',
        borderClass: function(item) {
          var borderStyle = 'info',
              taskState = BULK_ACTIONS_STATES[item.state];
          if (!_.isUndefined(taskState)) {
            borderStyle = taskState.borderStyle;
          }
          return 'progress-border-' + borderStyle;
        }
      };

      ctrl.list = new List({ idField: '_id' });

      var listName = 'bulk-actions';
      ctrl.searchModel = Profile.getListPreferences(listName).current;
      var searchCode = 'search';

      AsyncTasksSearch.getSearch(searchCode)
        .then(function(search) {
          var listOptions = {
            search: search,
            model: ctrl.searchModel,
            idField: 'id',
            defaultFilter: { tool: 'csv_kaizen' },
            searchFn: CeleryTasks.searchIds.bind(CeleryTasks),
            fetchFn: CeleryTasks.fetchIds.bind(CeleryTasks)
          };

          search.ready = true;
          return new ApiIDList(listOptions);
        })
        .then(function(list) {
          ctrl.list = list;
          $rootScope.$broadcast('KZCurrentListChange', { list: listName, search: list.search });
          $rootScope.loading = false;
          ctrl.list.doLoadItems();
          ctrl.loaded = true;
        })
        .catch(function(error) {
          $rootScope.loading = false;
          ctrl.loaded = true;
          $log.warn(error);
        });

      ctrl.actions = [
        {
          label: $translate.instant('Create new bulk action'),
          icon: 'icon-plus',
          route: ['/bulk-actions/new'],
          klass: 'btn-success'
        }
      ];
    };
  }

  BulkActionsController.$inject = [
    '$log',
    '$rootScope',
    '$translate',
    'APIIDListFactory',
    'AsyncTasksSearch',
    'CeleryTasksService',
    'ProfileService',
    'ListFactory',
    'UtilsService',
    'BULK_ACTIONS_STATES'
  ];

  angular.module('component.bulkActions')
    .controller('BulkActionsController', BulkActionsController);
})();
